import React from 'react'
import { Checkbox, TimePicker } from '@duck/ui'
import { useTar } from '@/modules'

type AssignmentDateTimePickerProps = {
  label: string
  canEnable?: boolean
  enabled: boolean
  onEnabledChange: (enabled: boolean) => void
  date: Date | undefined
  onDateChange: (date: Date | undefined) => void
  time: string | undefined
  onTimeChange: (time: string) => void
  error?: string
}

export const AssignmentDateTimePicker: React.FC<AssignmentDateTimePickerProps> = ({
  label,
  canEnable = true,
  enabled,
  onEnabledChange,
  date,
  onDateChange,
  time,
  onTimeChange,
  error,
}) => {
  const { t } = useTar()
  const isEnabled = enabled && canEnable

  return (
    <div className="flex flex-col gap-1">
      <div className="flex flex-row gap-1 space-x-4">
        <label className="flex items-center gap-2 flex-1 cursor-pointer">
          <Checkbox
            checked={isEnabled}
            disabled={!canEnable}
            onCheckedChange={(checked) => {
              if (!canEnable) return
              onEnabledChange(checked === true)
              if (checked === true) {
                onTimeChange('00:00')
              }
            }}
          />
          <span className="text-sm font-medium text-muted-foreground">{label}</span>
        </label>
        <TimePicker
          time={time}
          onTimeChange={onTimeChange}
          datePickerProps={{
            value: date,
            onChange: onDateChange,
            disabled: !isEnabled,
          }}
          inputProps={{
            placeholder: t('common.selectTime'),
            disabled: !isEnabled,
          }}
        />
      </div>
      {isEnabled && error ? (
        <div className="text-sm text-destructive">{error}</div>
      ) : null}
    </div>
  )
}
